import { createApp } from 'vue'
import App from './App.vue'
import { createPinia } from 'pinia'
import router from './router'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
// 导入常用Element Plus图标
import { User, Document, Menu, ArrowDown, Search, Setting, House as Home, Check, Money, Promotion, ChatDotRound, Refresh } from '@element-plus/icons-vue'

const app = createApp(App)

// 创建性能更好的应用实例
const pinia = createPinia()

app.use(ElementPlus, {
  locale: zhCn
})
// 注册Element Plus图标
const elementIcons = {
  User,
  Document,
  Menu,
  ArrowDown,
  Search,
  Setting,
  Home,
  Check,
  Money,
  Promotion,
  ChatDotRound,
  Refresh
}

// 注册图标
Object.entries(elementIcons).forEach(([key, component]) => {
  app.component(key, component)
})

// 使用pinia
app.use(pinia)

// 使用路由
app.use(router)

// 挂载应用
app.mount('#app')
